import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const activePlayerSelector = createSelector(
  (state: RootState) => state.game.game,
  (game) => {
    if (!game?.activePlayerId) {
      return undefined;
    }

    const activePlayer = game!.membersMap[game!.activePlayerId!];

    return activePlayer;
  }
);
